import { computed } from 'vue';

export default function useBreadcrumbs() {
  const disabledBreadcrumbKeys = computed(() => {
    return ['master-data', 'company-settings', 'quality', 'process-control'];
  });

  function isDisabledBreadcrumb(crumb) {
    return Boolean(crumb.disabled) || disabledBreadcrumbKeys.value.includes(crumb.key);
  }

  return {
    disabledBreadcrumbKeys,
    isDisabledBreadcrumb,
  };
}
